const events = {
  all: 'All',
  categories: {
    ACCESS: 'Access',
    ALARM: 'Alarm',
    CONFIGURATION: 'Configuration',
    DETAILED_ACCESS: 'Detailed Access',
    HARDWARE: 'Hardware',
    INTEGRATION: 'Integration',
    SYSTEM: 'System',
    WARNING: 'Warning',
  },
  general: {
    add: 'Add',
    assign: 'Assign',
    fetchError: 'Failed to fetch data',
  },
  selectors: {
    selector2: {
      security: 'Security',
      lockdown: 'Lockdown',
    },
    selector3: {
      user: 'User',
    },
  },
  table: {
    object: 'Object',
    instigator: 'Instigator',
  },
};

export default events;
